import { render, staticRenderFns } from "./MenuMargins.vue?vue&type=template&id=0266451c&scoped=true&"
import script from "./MenuMargins.vue?vue&type=script&lang=js&"
export * from "./MenuMargins.vue?vue&type=script&lang=js&"
import style0 from "./MenuMargins.vue?vue&type=style&index=0&id=0266451c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0266451c",
  null
  
)

export default component.exports